import React from 'react'
import Home from "./Home";
import About from "./About";
import Work from "./Work";
import Testimonial from "./Testimonial";
import Contact from "./Contact";
import Footer from "./Footer";

import { useRef } from "react";


function MainPage() {
    const aboutRef = useRef()
    return (
        <div>

            <Home />
            <Work />
            <About refin={aboutRef} />
            <Testimonial />
            <Contact />
            <Footer />


        </div>
    )
}

export default MainPage